var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMondayWorkManagementSquare = function SvgMondayWorkManagementSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6CFF",
    d: "M16.367 52.545c-2.709-1.847-3.367-5.482-1.47-8.12l16.007-22.259c1.172-1.63 3.045-2.497 4.945-2.486 1.896-.008 3.766.86 4.936 2.486l16.012 22.266c1.896 2.637 1.238 6.272-1.47 8.119-2.71 1.846-6.442 1.205-8.339-1.432L35.844 35.623l-11.139 15.49c-1.896 2.637-5.63 3.278-8.338 1.432"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2108_574604)",
    d: "M16.372 18.724c-2.709 1.847-3.367 5.482-1.47 8.119l16 22.25c1.168 1.624 3.032 2.49 4.925 2.486 1.904.015 3.783-.853 4.958-2.486l16-22.25c1.897-2.637 1.239-6.272-1.47-8.119s-6.442-1.206-8.338 1.432L35.843 35.637 24.71 20.156c-1.897-2.638-5.63-3.279-8.338-1.432"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7E7EFF",
    d: "m28.532 25.47-7.31 10.163 7.31 10.164 7.31-10.164z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2108_574604",
    x1: 39.285,
    x2: 37.456,
    y1: 34.624,
    y2: 52.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABAFD"
  })))));
};
export default SvgMondayWorkManagementSquare;